"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATE_PICKER_MONTHS = exports.DATE_PICKER_DAYS = void 0;
var DATE_PICKER_DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
exports.DATE_PICKER_DAYS = DATE_PICKER_DAYS;
var DATE_PICKER_MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
exports.DATE_PICKER_MONTHS = DATE_PICKER_MONTHS;